import Link from "next/link";

export default () => (
  <Link href="/products">
    <button className="transition-all rounded bg-primary shadow-md text-white font-semibold px-5 py-2 hover:scale-105 active:scale-100 hover:shadow-lg active:shadow">
      View All
    </button>
  </Link>
);
